<ng-container *ngIf="(item.hidden && !item.hidden(item)) || !item.hidden">
  <div class="fuse-vertical-navigation-item-wrapper">
    <div
      class="fuse-vertical-navigation-item"
      [ngClass]="{
        'fuse-vertical-navigation-item-disabled': item.disabled,
        'fuse-vertical-navigation-item-active': hasActiveChild
      }"
    >
      <!-- Icon -->
      <div
        class="fuse-vertical-navigation-item-icon"
        (click)="toggleCollapsable()"
      >
        <ng-container *ngIf="item.icon">
          <i [class]="item.icon"></i>
        </ng-container>
        <ng-container *ngIf="item.svgIcon">
          <img [src]="item.svgIcon" alt="svg-icon" />
        </ng-container>
      </div>

      <!-- Title -->
      <div
        class="fuse-vertical-navigation-item-title-wrapper"
        (click)="toggleCollapsable()"
      >
        <div  class="fuse-vertical-navigation-item-title">
          {{ item.title }}
        </div>
      </div>

      <!-- Arrow -->
      <i
        class="ri-arrow-down-s-line fuse-vertical-navigation-item-arrow"
        (click)="toggleCollapsable(true)"
      ></i>
    </div>
  </div>

  <div
    class="fuse-vertical-navigation-item-children"
    *ngIf="!isCollapsed"
    @expandCollapse
  >
    <ng-container *ngFor="let item of item.children; trackBy: trackByFn">
      <!-- Basic -->
      <ng-container *ngIf="item.type === 'basic'">
        <app-basic-item [item]="item" (click)="closeNav.emit()" ></app-basic-item>
      </ng-container>
      <!-- Collapsable -->
      <ng-container *ngIf="item.type === 'collapsable'">
        <app-collapsable-item [item]="item"
                              [name]="name"
                              [autoCollapse]="autoCollapse">
        </app-collapsable-item>
      </ng-container>
    </ng-container>
  </div>
</ng-container>
